import { Toast } from '@m/alchemy-ui/Toast';

import {
  generateAutoDismissMessage,
  useToasts
} from 'settings/hooks/useToasts';
import server from 'common/utils/server';

import {
  SettingsDashboardItem,
  SettingsDashboardItemProps
} from '../SettingsDashboardItem';

export function EnableCompanyDashboardItem({
  id,
  link: enableUrl,
  title,
  subtitle,
}: SettingsDashboardItemProps) {
  const { messages, showMessage } = useToasts();

  const enableCompany = () => {
    server
      .patch(enableUrl, undefined, { format: 'json' })
      .then((data: { detail: string }) => {
        const message = generateAutoDismissMessage({
          level: 'confirm',
          content: data.detail,
        });
        showMessage(message);

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      });
  };

  return (
    <>
      <Toast messages={messages} />

      <SettingsDashboardItem
        id={id}
        title={title}
        subtitle={subtitle}
        onClick={enableCompany}
      />
    </>
  );
}
